import Api from '@teko/api';

class LocationService {
    constructor(locationApiUrl) {
        this.getProvinces = async () => {
            return this.locationApi
                .get('/location/provinces')
                .then(({ data }) => Promise.resolve(data.result.provinces));
        };
        this.getDistrictsByProvinceCode = async (provinceCode) => {
            return this.locationApi
                .get(`/location/districts?provinceCode=${provinceCode}`)
                .then(({ data }) => Promise.resolve(data.result.districts));
        };
        this.getWardsByDistrictCode = async (districtCode) => {
            return this.locationApi
                .get(`/location/wards?districtCode=${districtCode}`)
                .then(({ data }) => Promise.resolve(data.result.wards));
        };
        this.locationApi = new Api(locationApiUrl);
    }
}

export { LocationService };
